import { produce } from 'immer';

export const createPersonalInfoAgree = (set) => ({
  serviceParams: {},
  addServiceParams: (newParams) =>
    set(
      produce(({ personalInfoAgree }) => {
        personalInfoAgree.serviceParams = newParams;
      }),
    ),
  isRedirected: false,
  setIsRedirected: (newParams) =>
    set(
      produce(({ personalInfoAgree }) => {
        personalInfoAgree.isRedirected = newParams;
      }),
    ),
});
